import "react-app-polyfill/stable";
import "core-js";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// Global stylesheets recovered from the production CSS source maps:
//  - index.scss: base body font-family + margin reset (standard CRA global)
//  - loadingIndicator.scss: the app-wide loading animation (compiled into the
//    live build's main CSS, so it was imported globally in the original).
import "./index.scss";
import "./feature/core/styles/loadingIndicator.scss";

// NOTE: The current app (App.jsx) uses React Context + react-router's
// createBrowserRouter for state and routing. The Redux <Provider>/store that
// appeared in the recovered (stale) index.js belonged to an OLD CoreUI-template
// build and is intentionally omitted here. See frontend-src/REBUILD-NOTES.md.

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
